import React, { useState } from 'react';

const Button = ({
  label,
  onClick,
  style,
  type = 'button',
  to,
  base = '#c026d3',
  hover = '#a21caf',
  pressed = '#701a75',
}) => {
  const [isPressed, setIsPressed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const backgroundColor = isPressed
    ? pressed
    : isHovered
    ? hover
    : base;

  const sharedStyles = {
    width: '100%',
    border: 'none',
    backgroundColor,
    color: '#ffffff',
    fontSize: '1rem',
    fontWeight: 500,
    padding: '0.8rem 0',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease, transform 0.1s ease',
    appearance: 'none',
    WebkitAppearance: 'none',
    textAlign: 'center',
    outline: 'none',
    display: 'inline-block',
    ...style,
  };

  if (to) {
    return (
      <a
        href={to}
        style={{
          textDecoration: 'none',
          ...sharedStyles,
        }}
        onClick={onClick}
        onMouseDown={() => setIsPressed(true)}
        onMouseUp={() => setIsPressed(false)}
        onMouseLeave={() => {
          setIsPressed(false);
          setIsHovered(false);
        }}
        onMouseEnter={() => setIsHovered(true)}
      >
        {label}
      </a>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      style={sharedStyles}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => {
        setIsPressed(false);
        setIsHovered(false);
      }}
      onMouseEnter={() => setIsHovered(true)}
    >
      {label}
    </button>
  );
};

export default Button;
